<template>
  <v-text-box class="text">
    <template #box-title>αγιος νικολαος</template>
    <template #box-text>{{ infoText }}</template>
  </v-text-box>
</template>

<script>
import VTextBox from '@/components/modules/VTextBox.vue';
export default {
  name: 'AgiosHeroTextBox',
  components: {
    VTextBox,
  },
  data() {
    return {
      info: {
        p1:
          'Ο Άγιος Νικόλαος είναι ένα από τα παλαιότερα χωριά στη Χαλκιδική και παρουσιάζει ιδιαίτερο ιστορικό ενδιαφέρον. Ο Άγιος Νικόλαος είναι ένας παραδοσιακός οικισμός με πανέμορφα οικήματα και γραφικά, στενά σοκάκια. Η ιστορία του είναι μακρά και ξεκινά από τα προϊστορικά χρόνια, όπως μαρτυρούν τα ίχνη ενός προϊστορικού οικισμού, που ανακαλύφθηκαν νοτιοδυτικά του χω ριού στον λόφο Βετρύνο.Το χωριό βρίσκεται σε μια ειδυλλιακή τοποθεσία, εν μέσω πυκνών, καταπράσινων δασών.',
        p2:
          'Το επίνειο του Αγίου Νικολάου είναι το μικρό λιμάνι, Όρμος Παναγιάς, μόλις 2,5 χιλιόμετρα από το χωριό, απ’ όπου τουριστικά σκάφη πραγματοποιούν καθημερινά κρουαζιέρες στο Άγιο Όρος, καθώς και μικρές στάσεις στο εξωτικό νησάκι της Χαλκιδικής, την Αμμουλιανή και στην Ουρανούπολη, την πύλη του Αγ.Όρους.',
      },
      infoText:
        'Ο Άγιος Νικόλαος είναι ένα από τα παλαιότερα χωριά στη Χαλκιδική καθώς η ιστορία του είναι μακρά και ξεκινά από τα προϊστορικά χρόνια. Το χωριό βρίσκεται σε μια ειδυλλιακή τοποθεσία, εν μέσω πυκνών, καταπράσινων δασών, μόλις 2 χιλιόμετρα από τη θάλασσα. Τα γραφικά σοκάκια του περιστοιχίζονται από όμορφα οικήματα με ανθισμένους κήπους. Σημείο αναφοράς του αποτελεί η μεγάλη πλατεία όπου περιμετρικά της υπάρχουν ταβέρνες, καφετέριες και μαγαζιά. Εκεί συχνά, διοργανώνονται λαϊκές βραδιές με ζωντανή μουσική. Στο χωριό θα βρείτε επίσης σούπερ μάρκετ, κομμωτήρια, Κέντρο Υγείας, φαρμακεία και ΑΤΜ.',
    };
  },
};
</script>

<style lang="scss" scoped>
.text {
  width: 60%;
}

@media (max-width: 900px) {
  .text {
    width: 100%;
  }
}
</style>
